export var menuItems = {
  "data": [
    // {
    //   "headTitle1": "General",
    //   "headTitle2": "Dashboards,Widgets & Layout.",
    //   "type": "headtitle"
    // },
    // {
    //   "title": "Dashboard",
    //   "icon": "stroke-home",
    //   "iconf":"fill-home",
    //   "icony":"fa fa-dashboard",
    //   "type": "sub",
    //   "active": false,
    //   "children": [
    //     {
    //       "path": "/",
    //       "title": "Dashboard",
    //       "type": "link",
    //       "active":false
    //     },
    //   ]
    // },
    {
      "path": "/",
      "title": "Dashboard",
      "icon": "stroke-board",
      "iconf": "fill-board",
      "icony": "fa fa-dashboard",
      "type": "link",
      "active": false
    },
    {
      "title": "Users",
      "icon": "stroke-user",
      "iconf": "fill-user",
      "icony": "fa fa-users",
      "type": "sub",
      "active": false,
      "children": [
        {
          "path": "/users/adduser",
          "title": "Add User",
          "type": "link",
          "active": false
        },
        {
          "path": "/users/viewuser",
          "title": "View Users",
          "type": "link",
          "active": false
        },
        {
          "path": "/users/deleteuser",
          "title": "Deleted Users",
          "type": "link",
          "active": false
        },
        {
          "path": "/users/disableuser",
          "title": "Disabled Users",
          "type": "link",
          "active": false
        }
      ]
    },
    // {
    //   "path": "/brands",
    //   "title": "Brands",
    //   "icon": "stroke-board",
    //   "iconf": "fill-board",
    //   "icony": "fa fa-certificate",
    //   "type": "link",
    //   "active": false
    // },
    // {
    //   "path": "/models",
    //   "title": "Models",
    //   "icon": "stroke-task",
    //   "iconf": "fill-task",
    //   "icony": "fa fa-cubes",
    //   "type": "link",
    //   "active": false
    // },
    {
      "title": "Sliders",
      "icon": "stroke-layout",
      "iconf": "fill-layout",
      "icony": "fa fa-sliders",
      "type": "sub",
      "active": false,
      "children": [
        {
          "path": "/sliders/addgroup",
          "title": "Add Group",
          "type": "link",
          "active": false
        },
        {
          "path": "/sliders/groups",
          "title": "Groups",
          "type": "link",
          "active": false
        },
        {
          "path": "/sliders/gerneralsliders",
          "title": "General Sliders",
          "type": "link",
          "active": false
        },
        {
          "path": "/sliders/locationsliders",
          "title": "Location Sliders",
          "type": "link",
          "active": false
        }
      ]
    },
    {
      "path": "/types",
      "title": "Category Types",
      "icon": "stroke-category",
      "iconf": "fill-category",
      "icony": "fa fa-list",
      "type": "link",
      "active": false
    },
    {
      "path": "/categories",
      "title": "Categories",
      "icon": "stroke-learning",
      "iconf": "fill-learning",
      "icony": "fa fa-tasks",
      "type": "link",
      "active": false
    },
    {
      "path": "/subcategories",
      "title": "Sub Categories",
      "icon": "stroke-subcategory",
      "iconf": "fill-subcategory",
      "icony": "fa fa-th-list",
      "type": "link",
      "active": false
    },
    {
      "title": "Attributes",
      "icon": "stroke-animation",
      "iconf": "fill-animation",
      "icony": "fa fa-sitemap",
      "type": "sub",
      "active": false,
      "children": [
        {
          "path": "/attributes/addattribute",
          "title": "Add Attribute",
          "type": "link",
          "active": false
        },
        {
          "path": "/attributes/viewattribute",
          "title": "View Attributes",
          "type": "link",
          "active": false
        },
      ]
    },
    {
      "title": "Products",
      "icon": "stroke-vehicle",
      "iconf": "fill-vehicle",
      "icony": "fa fa-car",
      "type": "sub",
      "active": false,
      "children": [
        {
          "path": "/products/addproduct",
          "title": "Add Product",
          "type": "link",
          "active": false
        },
        {
          "path": "/products/products",
          "title": "Products",
          "type": "link",
          "active": false
        },

        {
          "path": "/products/soldproducts",
          "title": "Sold Products",
          "type": "link",
          "active": false
        },
      ]
    },
    // {
    //   "path": "/category_attributes",
    //   "title": "Category Attributes",
    //   "icon": "stroke-learning",
    //   "iconf":"fill-learning",
    //   "icony":"fa fa-dedent",
    //   "type": "link",
    //   "active": false
    // },
    // {
    //   "title": "Vehicles",
    //   "icon": "stroke-vehicle",
    //   "iconf": "fill-vehicle",
    //   "icony": "fa fa-car",
    //   "type": "sub",
    //   "active": false,
    //   "children": [
    //     {
    //       "path": "/vehicles/addvehicle",
    //       "title": "Add Vehicle",
    //       "type": "link",
    //       "active": false
    //     },
    //     {
    //       "path": "/vehicles/existingvehicles",
    //       "title": "Existing Vehicles",
    //       "type": "link",
    //       "active": false
    //     },
    //     {
    //       "path": "/vehicles/soldvehicles",
    //       "title": "Sold Vehicles",
    //       "type": "link",
    //       "active": false
    //     },
    //   ]
    // },
    // {
    //   "title": "Accessories & Spare Parts",
    //   "icon": "stroke-animation",
    //   "iconf": "fill-animation",
    //   "icony": "fa fa-gears",
    //   "type": "sub",
    //   "active": false,
    //   "children": [
    //     {
    //       "path": "/accessories/addaccessory",
    //       "title": "Add Accessory / Spare Parts",
    //       "type": "link",
    //       "active": false
    //     },
    //     {
    //       "path": "/accessories/existingaccessories",
    //       "title": "Existing Accessories & Spare Parts",
    //       "type": "link",
    //       "active": false
    //     },
    //     {
    //       "path": "/accessories/soldaccessories",
    //       "title": "Sold Accessories & Spare Parts",
    //       "type": "link",
    //       "active": false
    //     },
    //   ]
    // },
    {
      "title": "Reports",
      "icon": "stroke-knowledgebase",
      "iconf": "fill-knowledgebase",
      "icony": "fa fa-file-text",
      "type": "sub",
      "active": false,
      "children": [
        {
          "path": "/reports/customers",
          "title": "Customers",
          "type": "link",
          "active": false
        },
        {
          "path": "/reports/products",
          "title": "Products",
          "type": "link",
          "active": false
        },
        // {
        //   "path": "/reports/accessories",
        //   "title": "Accessories",
        //   "type": "link",
        //   "active": false
        // },
        // {
        //   "path": "/reports/vehicles",
        //   "title": "Vehicles",
        //   "type": "link",
        //   "active": false
        // },
      ]
    },
    {
      "path": "/notifications",
      "title": "Notifications",
      "icon": "stroke-button",
      "iconf": "fill-botton",
      "icony": "fa fa-paper-plane",
      "type": "link",
      "active": false
    },
    {
      "path": "/reportedProblems",
      "title": "Reported Problems",
      "icon": "stroke-editors",
      "iconf": "fill-editors",
      "icony": "fa fa-exclamation-triangle",
      "type": "link",
      "active": false
    },
    {
      "path": "/settings",
      "title": "Settings",
      "icon": "stroke-internationalization",
      "iconf": "fill-internationalization",
      "icony": "fa fa-gear",
      "type": "link",
      "active": false
    },

  ]
}